import React, { useRef, useEffect } from 'react';
import Message from './Message';
import MessageInput from './MessageInput';
import LoadingIndicator from './LoadingIndicator';
import WelcomeMessage from './WelcomeMessage';
import './ChatContainer.css';

const ChatContainer = ({ messages, onSendMessage, isLoading, isConnected, isBltzShieldEnabled }) => {
  const messagesEndRef = useRef(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div className={`chat-container ${isBltzShieldEnabled ? 'bltz-shield-active' : ''}`}>
      <div className="messages-container">
        {messages.length === 0 ? (
          <WelcomeMessage isConnected={isConnected} />
        ) : (
          <div className="messages-list">
            {messages.map((message) => (
              <Message key={message.id} message={message} />
            ))}
            {isLoading && <LoadingIndicator />}
            <div ref={messagesEndRef} />
          </div>
        )}
      </div>
      
      <MessageInput 
        onSendMessage={onSendMessage} 
        isLoading={isLoading}
        isConnected={isConnected}
      />
    </div>
  );
};

export default ChatContainer;